<template>
  <div>
    <div class="query-form">
      <el-form class="elementui-common-form-styles" v-highlight label-width="50" inline>
        <el-form-item label-width="0">
          <el-input
            v-model.trim="queryForm.ruleName"
            placeholder="请输入任务名称或ID"
            clearable
            style="width: 200px"
            :maxlength="20"
            @keyup.enter.native="queryAction"
            @clear="queryAction"
          >
            <i slot="append" @click="queryAction" class="el-icon-search"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="类型" label-width="40px">
          <el-select v-model="queryForm.controlType" @change="queryAction" clearable style="width: 120px" placeholder="全部">
            <el-option v-for="item in DATA_TYPE_LIST" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="gotoFormPage" v-if="permissions.includes('M21025')">新建上报任务</el-button>
    </div>

    <Viewport v-model="reportGridOptions.height" v-loading="tableLoading">
      <vxe-grid ref="xGrid" v-bind="reportGridOptions">
        <!-- 任务开关列 -->
        <template #switch="{ row }">
          <el-switch
            class="table-row-toggle-switch"
            @change="onTaskStateChange($event, row)"
            v-loading="row.switchLoading"
            :disabled="row.switchLoading"
            v-model="row.stateSwitch"
          />
        </template>

        <!-- 操作列 -->
        <template #operation="{ row }">
          <el-button type="text" v-if="permissions.includes('M21026')" @click="gotoFormPage(row)">编辑</el-button>
          <el-button type="text" v-if="permissions.includes('M21028')" @click="onRemoveTableRow(row)">删除</el-button>
          <el-button type="text" v-if="permissions.includes('M21038')" @click="gotoLogPage(row)">日志</el-button>
        </template>
      </vxe-grid>

      <div class="pager">
        <el-pagination
          :current-page.sync="pager.pageIndex"
          :page-size.sync="pager.pageSize"
          :total="pager.total"
          :page-sizes="[10, 20, 30, 40, 50]"
          @current-change="search"
          @size-change="queryAction"
          layout="sizes, prev, pager, next, total"
          background
        >
        </el-pagination>
      </div>
    </Viewport>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils.js'
import DataReports from './data/data-reports.class.js'
import { getDataReportingInfoByPage, updateDataReportConfigStatus } from '@/api/report.model'

export default {
  name: 'data-report-list',
  data() {
    return {
      queryForm: { ruleName: '', controlType: '' },
      tableLoading: false,
      reportGridOptions: DataReports.getGridOptions(),
      pager: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    permissions() {
      return this.$store.state.accessAuth
    },
    DATA_TYPE_LIST() {
      return DataReports.DATA_TYPE_LIST
    }
  },
  activated() {
    this.search()
  },
  methods: {
    queryAction() {
      this.pager.pageIndex = 1
      this.search()
    },
    /**
     * @description: 分页获取任务数据
     * @return {*}
     */
    search() {
      const { total, ...pager } = this.pager
      this.tableLoading = true
      getDataReportingInfoByPage({ ...pager, ...this.queryForm })
        .then((data) => {
          const { list, page_info } = data
          const status = [false, true]
          if (isArray(list)) {
            this.reportGridOptions.data = list.map((item) => ({ ...item, switchLoading: false, stateSwitch: status[item.status] }))
            this.pager.total = page_info.total_number
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    /**
     * @description: 开启关闭任务
     * @param {*} e
     * @param {*} row
     */
    async onTaskStateChange(e, row) {
      const status = e ? 1 : 0
      try {
        row.switchLoading = true
        const res = await this.updateRowStatus({ ruleId: row.ruleId, status })
        row.switchLoading = false
        if (res) {
          this.$Message.info('操作成功')
        }
      } catch (e) {
        console.log('onTaskStateChange error output: ', e)
        row.switchLoading = false
      }
    },
    /**
     * @description: 删除任务
     * @param {*} row
     */
    async onRemoveTableRow(row) {
      try {
        await this.$confirm(`确认删除任务${row.ruleName}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        this.tableLoading = true

        const res = await this.updateRowStatus({ ruleId: row.ruleId, status: -1 })
        if (res) {
          this.$Message.info('删除成功')
          this.search()
        }
        this.tableLoading = false
      } catch (e) {
        console.log('eeeeee output: ', e)
        this.tableLoading = false
      }
    },
    updateRowStatus(params) {
      if (params) {
        return updateDataReportConfigStatus(params)
      }
      return Promise.reject(new Error('参数不能为空'))
    },

    gotoFormPage({ ruleId }) {
      const route = { name: 'data-report-form' }
      if (ruleId) {
        route.query = { ruleId }
      }
      this.$router.push(route)
    },
    gotoLogPage({ ruleId }) {
      this.$router.push({ name: 'data-report-log', query: { ruleId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.query-form {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

::v-deep .table-row-toggle-switch {
  .el-loading-spinner {
    .circular {
      width: 12px;
    }
  }
}

.pager {
  text-align: right;
  padding: 5px 0;
}
</style>
